import React from 'react'
import { tenantColors } from '../../../_constants/colors'
import { AuthConfig } from '../../../_configs'
import urls from '../../../_constants/urls'
import { connect } from 'react-redux'
import { S_EmailConfirmation } from './styles'
import { useLocation } from 'react-router-dom'
import { Button } from '../../../_components/Button'
import { notificationActionHooks } from '../../../_actionHooks'

import { resendRegistrationEmail } from '../../../_services/underwrite.service'

const EmailConfirmation = ({ tenant, env }) => {
  const config = AuthConfig[tenant]
  const bgImage = `${urls.IMAGES}/${env}/${tenant}/sign_bg.jpg`

  const showNotification = notificationActionHooks.useShowNotification()

  function useQuery() {
    const { search } = useLocation()

    return React.useMemo(() => new URLSearchParams(search), [search])
  }
  const query = useQuery()
  const email = query.get('email')
  const deal_id = query.get('deal_id')

  const resendEmail = () => {
    resendRegistrationEmail(deal_id).then(() => {
      showNotification({ id: 'create-contact-noty', type: 'success', message: `An email was sent to ${email}` })
    })
  }

  return (
    <S_EmailConfirmation
      bg={config.common.show_auth_bg ? bgImage : false}
      bg_size="cover"
      customColors={tenantColors[tenant]}
    >
      <div className={'content'}>
        <div>
          <h1 className="title">Thank you for signing up!</h1>
        </div>
        <div className="email_section">
          We will send an e-mail to <span className="email">{email}</span> shortly.
        </div>
        <div className="buttons_section">
          <Button
            buttonType={`button`}
            className={`submit-btn`}
            onClick={() => resendEmail()}
            text="RESEND EMAIL"
            type={`submit`}
          />
        </div>
      </div>
    </S_EmailConfirmation>
  )
}

function mapStateToProps(state) {
  const { env } = state
  return {
    env: env.env,
    tenant: env.tenant,
  }
}

const connectedEmailConfirmation = connect(mapStateToProps)(EmailConfirmation)
export { connectedEmailConfirmation as EmailConfirmation }
